/* eslint-disable no-param-reassign */
import { createNextState } from '@reduxjs/toolkit';
import { GET_NOTIFICATIONS } from 'src/redux/actions/notificationsActions';

const initialState = {
  notifications: []
};

const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTIFICATIONS: {
      const { notifications } = action.payload;

      return createNextState(state, (draft) => {
        draft.notifications = notifications;
      });
    }

    default: {
      return state;
    }
  }
};

export default notificationsReducer;
